import { render, staticRenderFns } from "./pc-header.vue?vue&type=template&id=b4967f22&scoped=true"
import script from "./pc-header.vue?vue&type=script&lang=js"
export * from "./pc-header.vue?vue&type=script&lang=js"
import style0 from "./pc-header.vue?vue&type=style&index=0&id=b4967f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4967f22",
  null
  
)

export default component.exports